import React from 'react';
import { RouteObject } from 'react-router-dom';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import { appRoutes } from '../../path';
import ProtectedRoute from '../../components/ProtectedRoute';
import Formulas from './Formulas';
import Query from './Query';
import Funnel from './Funnel';
import Path from './Path';
import Retention from './Retention';
import Prediction from './Prediction';
import DataTable from './DataTable';
import Significance from './Significance';
import RedirectRoute from '../RedirectRoute';
import SidebarLayout from '../../Layout/SidebarLayout';
import ReportNav from './ReportNav';

const reportRoutes: RouteObject[] = [
  {
    path: '/formula/*',
    element: (
      <RedirectRoute from="/formula/*" to={appRoutes.report.routePrefix} />
    ),
  },
  {
    path: appRoutes.report.routePrefix,
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.AnalysisRead]}>
        <SidebarLayout>
          <ReportNav />
        </SidebarLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: (
          <RedirectRoute
            from={appRoutes.report.routePrefix}
            to={appRoutes.report.query}
          />
        ),
      },
      {
        element: <Formulas />,
        children: [
          { path: 'query/:builderId?', element: <Query /> },
          { path: 'funnel/:builderId?', element: <Funnel /> },
          { path: 'path/:builderId?', element: <Path /> },
          { path: 'retention/:builderId?', element: <Retention /> },
          { path: 'prediction/:builderId?', element: <Prediction /> },
          { path: 'data-table/:builderId?', element: <DataTable /> },
          { path: 'significance/:builderId?', element: <Significance /> },
        ],
      },
    ],
  },
];

export default reportRoutes;
